export default function () {
  return {
    deportes: [],   
  };
}
